/// <amd-module name="typeahead/core/presentation/IInputElementFocusByHumanOrScriptHandler" />

/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../../typings/thirdparty/jquery/jquery.d.ts" />
/// <reference path="../../../typings/typeahead/plugins.d.ts" />

// Handles the events when an <input> element receives focus regardless of the immediate cause, whether it was due to
// a click/tap on the element, or script execution. For example, expanding the change search wizard on flights search
// results page causes its origin <input> to be focused, despite that it is not clicked on.
export interface IInputElementFocusByHumanOrScriptHandler<T> {
    handleInputElementFocusByHumanOrScript($inputElement: JQuery, context: IContext): JQueryPromise<T>;
}

export const isInputElementFocusByHumanOrScriptHandler: IPluginIdentifier = (plugin: Object): boolean => {
    return _.isObject(plugin)
        && _.isFunction(
            (plugin as IInputElementFocusByHumanOrScriptHandler<any>).handleInputElementFocusByHumanOrScript);
};
